import { type Element, type RequiredParamsType, RequiredTargetingSectionKeys } from '../context/types.ts';

export const markMissingTargetingErrors = (nextState: RequiredParamsType): void => {
  const sectionKeys = Object.values(RequiredTargetingSectionKeys);

  const missingSections = new Set(
    sectionKeys.filter(
      key => !nextState.sections[key]?.elements?.some((element: Element) => element.mainOption.isSelected)
    )
  );

  if (missingSections.size === sectionKeys.length) return;

  sectionKeys.forEach(sectionKey => {
    const section = nextState.sections[sectionKey];
    if (!section?.elements) return;

    const sectionHasError = missingSections.has(sectionKey);
    let sectionChanged = false;

    const newElements: Element[] = section.elements.map((element: Element) => {
      const shouldMarkAsError = sectionHasError && !element.mainOption.isDisabled;

      if (element.mainOption.isError === shouldMarkAsError) return element;

      sectionChanged = true;

      return { ...element, mainOption: { ...element.mainOption, isError: shouldMarkAsError } };
    });

    if (sectionChanged) section.elements = newElements;
  });
};
